import * as React from "react";
import { Heading, Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import Layout from "../../../../components/Layout/components/Layout/Layout.js";
import Login from "../../../../modules/Login/modules/Login/Login.js";
const LoginPage = (props) => {
  const { isOrderNumberValid } = props;
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(Layout, null, /* @__PURE__ */ React.createElement(Heading, { component: "h1", variant: "small" }, getLabel("returns.page.login.title")), /* @__PURE__ */ React.createElement(Text, null, getLabel("returns.page.login.intro")), /* @__PURE__ */ React.createElement(Login, { isOrderNumberValid }));
};
export {
  LoginPage as default
};
//# sourceMappingURL=LoginPage.js.map
